import React from "react";
import CommonButtons from "src/shared/components/CommonButtons";

interface Props {
  balance: string | number;
  onPay: () => void;
  onRefund: () => void;
}

const OutstandingCard: React.FC<Props> = ({ balance, onPay, onRefund }) => {
  return (
    <div className='ledger-outstanding-card'>
      <h2 className='ledger-card-title'>Outstanding Balance</h2>

      <div
        id='balance type'
        className={`
      w-full px-4 py-2 rounded-lg mb-3 font-semibold flex text-xl
      ${Number(balance) < 0 ? "text-green-700" : "text-red-700"}
    `}
      >
        {Number(balance) < 0 ? "Advance" : "Outstanding"}
      </div>

      <h1 className={`text-5xl font-bold ${Number(balance) < 0 ? "text-green-700" : "text-red-700"}`}>{Math.abs(Number(balance))}</h1>

      {Number(balance) > 0 ? (
        <CommonButtons label='Make Payment' onClick={onPay} className='w-full px-5 py-2.5 mt-4' />
      ) : (
        <CommonButtons label='Make Refund' onClick={onRefund} className='w-full px-5 py-2.5 mt-4' />
      )}
    </div>
  );
};

export default OutstandingCard;
